import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretUp = () => {
  return (
    <g>
      <path d="m14.2563 11.45c.605 0 .75-.35.3222-.7778l-5.8007-5.801a1.1032 1.1032 0 0 0 -1.5556 0l-5.8006 5.8006c-.4278.4278-.2828.7778.3222.7778h12.5125z" />
    </g>
  );
};

export default withIcon(IconCaretUp);
